<template>
    <div>
        <head-title title="Login" />

        <h2 class="text-center mb-4">Login</h2>

        <div class="text-center mt-4">
            <form class="mt-4" @submit.prevent="submit">
                <validation-observer ref="form">
                    <text-input
                        v-model="form.email"
                        type="email"
                        required
                        name="Email"
                        rules="required"
                    />
                    <text-input
                        v-model="form.password"
                        type="password"
                        required
                        name="Password"
                        rules="required"
                        autocomplete="current-password"
                    />

                    <div class="d-flex">
                        <inertia-link href="/forgot-password">
                            Forgot Password?
                        </inertia-link>

                        <v-btn
                            type="submit"
                            color="primary"
                            class="mt-4 ml-auto"
                            :loading="form.processing"
                        >
                            Login
                        </v-btn>
                    </div>
                </validation-observer>
            </form>
        </div>
        <div class="mt-8">
            <a :href="route('oauth.redirect', 'google')" class="inertia-link">
                <v-sheet elevation="2" class="pa-2">
                    <div class="d-flex" style="align-items: center">
                        <img
                            :src="$page.props.google_icon"
                            style="height: 48px"
                            alt="Google button"
                        />
                        <div class="ml-2 subtitle-1">Sign in with Google</div>
                    </div>
                </v-sheet>
            </a>

            <a
                :href="route('oauth.redirect', 'microsoft')"
                class="inertia-link"
            >
                <v-sheet elevation="2" class="pa-2 mt-4">
                    <div class="d-flex" style="align-items: center">
                        <img
                            :src="$page.props.microsoft_icon"
                            style="height: 48px"
                            alt="Google button"
                        />
                        <div class="ml-2 subtitle-1">
                            Sign in with Microsoft
                        </div>
                    </div>
                </v-sheet>
            </a>
        </div>
    </div>
</template>

<script>
import { required, max } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
import HeadTitle from "../Comps/Master/HeadTitle";
import TextInput from "../Comps/Forms/TextInput.vue";
import LoginLayout from "../Layouts/LoginLayout.vue";

extend("required", required);
extend("max", max);

export default {
    name: "Login",
    components: { TextInput, HeadTitle },
    layout: LoginLayout,

    data() {
        return {
            showForm: false,
            form: this.$inertia.form({
                email: "",
                password: "",
            }),
        };
    },

    methods: {
        async submit() {
            if (!(await this.$refs.form.validate())) {
                this.$toast.error("Please check for errors", {
                    duration: 5000,
                });

                return;
            }

            this.form.post("/fortify/login", {
                preserveScroll: true,
            });
        },
    },
};
</script>

<style scoped></style>
